var _rect, _g, _path, _path2, _path3, _path4, _path5, _ellipse, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMasking1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_309_19712",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 91,
    height: 91
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 91,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_309_19712)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -46.3586,
    y1: 49.3087,
    x2: 49.3086,
    y2: -46.3585,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: -26.8103,
    y1: 68.857,
    x2: 68.8569,
    y2: -26.8102,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: -36.5845,
    y1: 59.0824,
    x2: 59.0827,
    y2: -36.5849,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: -17.0361,
    y1: 78.6312,
    x2: 78.6311,
    y2: -17.036,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: -41.4716,
    y1: 54.1952,
    x2: 54.1957,
    y2: -41.4721,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: -25.1812,
    y1: 70.4862,
    x2: 70.486,
    y2: -25.181,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: -31.6974,
    y1: 63.9696,
    x2: 63.9699,
    y2: -31.6976,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: -12.149,
    y1: 83.5184,
    x2: 83.5182,
    y2: -12.1488,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: -44.7296,
    y1: 50.9374,
    x2: 50.9376,
    y2: -44.7299,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: -23.5523,
    y1: 72.1146,
    x2: 72.115,
    y2: -23.5526,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: -34.9554,
    y1: 60.7118,
    x2: 60.7118,
    y2: -34.9555,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: -15.407,
    y1: 80.2599,
    x2: 80.2602,
    y2: -15.4074,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: -39.8426,
    y1: 55.8246,
    x2: 55.8247,
    y2: -39.8427,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: -21.9232,
    y1: 73.744,
    x2: 73.7441,
    y2: -21.9232,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: -30.0684,
    y1: 65.599,
    x2: 65.5989,
    y2: -30.0683,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: -10.52,
    y1: 85.1468,
    x2: 85.1473,
    y2: -10.5204,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: -43.1006,
    y1: 52.5668,
    x2: 52.5666,
    y2: -43.1005,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: -20.2942,
    y1: 75.3732,
    x2: 75.3731,
    y2: -20.2941,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: -33.3264,
    y1: 62.3409,
    x2: 62.3408,
    y2: -33.3263,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: -13.7781,
    y1: 81.8893,
    x2: 81.8892,
    y2: -13.778,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: -38.2135,
    y1: 57.4537,
    x2: 57.4538,
    y2: -38.2135,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: -18.6651,
    y1: 77.0021,
    x2: 77.0021,
    y2: -18.6652,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: -28.4393,
    y1: 67.2274,
    x2: 67.2279,
    y2: -28.4398,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8.89097,
    y1: 86.7762,
    x2: 86.7763,
    y2: -8.891,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: -7.26203,
    y1: 88.4054,
    x2: 88.4052,
    y2: -7.26185,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.2863,
    y1: 107.954,
    x2: 107.954,
    y2: 12.2865,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.51217,
    y1: 98.1796,
    x2: 98.1794,
    y2: 2.51232,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.0605,
    y1: 117.728,
    x2: 117.728,
    y2: 22.0607,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: -2.37491,
    y1: 93.2924,
    x2: 93.2923,
    y2: -2.37489,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.9153,
    y1: 109.583,
    x2: 109.583,
    y2: 13.9156,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.39929,
    y1: 103.067,
    x2: 103.067,
    y2: 7.39928,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.9476,
    y1: 122.615,
    x2: 122.615,
    y2: 26.9481,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.2286,
    y1: 130.896,
    x2: 130.896,
    y2: 35.2291,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5.63297,
    y1: 90.0343,
    x2: 90.0343,
    y2: -5.63295,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.5444,
    y1: 111.212,
    x2: 111.212,
    y2: 15.5445,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.14114,
    y1: 99.8087,
    x2: 99.8084,
    y2: 4.14147,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.6896,
    y1: 119.357,
    x2: 119.357,
    y2: 23.6896,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.9706,
    y1: 127.638,
    x2: 127.638,
    y2: 31.9706,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.745977,
    y1: 94.9215,
    x2: 94.9213,
    y2: -0.74574,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.1734,
    y1: 112.841,
    x2: 112.841,
    y2: 17.1737,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.02822,
    y1: 104.696,
    x2: 104.695,
    y2: 9.02843,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.5767,
    y1: 124.244,
    x2: 124.244,
    y2: 28.5768,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.8577,
    y1: 132.525,
    x2: 132.525,
    y2: 36.8578,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.00403,
    y1: 91.6634,
    x2: 91.6632,
    y2: -4.0038,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.8024,
    y1: 114.47,
    x2: 114.47,
    y2: 18.8028,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.77017,
    y1: 101.438,
    x2: 101.437,
    y2: 5.77062,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.3186,
    y1: 120.986,
    x2: 120.986,
    y2: 25.319,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.5996,
    y1: 129.267,
    x2: 129.267,
    y2: 33.6,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.883081,
    y1: 96.5507,
    x2: 96.5503,
    y2: 0.88341,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.4315,
    y1: 116.099,
    x2: 116.099,
    y2: 20.4315,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.6573,
    y1: 106.325,
    x2: 106.325,
    y2: 10.6573,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.2056,
    y1: 125.873,
    x2: 125.873,
    y2: 30.2062,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.4867,
    y1: 134.154,
    x2: 134.154,
    y2: 38.4872,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.0339,
    y1: 135.701,
    x2: 135.701,
    y2: 40.0336,
    stroke: "#D9AA82",
    strokeWidth: 0.8
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.5957 61.3469H57.2441C57.0383 59.5834 55.6191 58.1851 53.8455 58.014C53.6419 56.1128 52.0291 54.627 50.075 54.627H25.8739C22.6351 54.627 20 57.262 20 60.5005V77.4692C20 79.4371 21.5058 81.059 23.4252 81.2445C23.6267 83.1254 25.2079 84.5987 27.1338 84.6297C27.1388 84.9634 27.1911 85.2856 27.2859 85.5897C27.7172 86.9744 29.0116 87.9826 30.5365 87.9826H57.5957C59.4729 87.9826 61 86.4555 61 84.5787V64.7512C61 62.8741 59.4729 61.3469 57.5957 61.3469ZM59.3984 64.7512V77.8631L55.915 75.2317C54.9632 74.5129 53.676 74.5017 52.7119 75.2039L48.3054 78.4145L39.9022 69.7511C38.9013 68.7188 37.2725 68.6553 36.1942 69.6069L28.7341 76.1886V64.7512C28.7341 63.7571 29.5427 62.9485 30.5365 62.9485H57.5957C58.5898 62.9485 59.3984 63.7571 59.3984 64.7512ZM59.3984 84.5784C59.3984 85.5725 58.5898 86.3811 57.5961 86.3811H30.5365C29.7292 86.3811 29.0438 85.8471 28.8155 85.1139C28.7626 84.9447 28.7341 84.7648 28.7341 84.5787V78.3241L37.254 70.8077C37.6898 70.423 38.3479 70.4486 38.7527 70.8659L42.5451 74.776C42.5451 74.7763 42.5451 74.7763 42.5454 74.7763L50.0937 82.5586C50.2508 82.7206 50.4594 82.8019 50.6687 82.8019C50.8695 82.8019 51.0706 82.7269 51.2261 82.5761C51.5433 82.268 51.5511 81.7612 51.2433 81.4437L49.4315 79.5757L53.655 76.4986C54.0448 76.2146 54.565 76.219 54.9497 76.5096L59.3984 79.87V84.5784ZM25.0049 80.8382V61.931C25.0049 61.8506 25.0089 61.7708 25.0171 61.6926C25.1366 60.5174 26.1322 59.5974 27.3384 59.5974H37.1336C37.5759 59.5974 37.9344 59.239 37.9344 58.7966C37.9344 58.3543 37.5759 57.9959 37.1336 57.9959H27.3384C25.1685 57.9959 23.4033 59.761 23.4033 61.931V79.6263C22.3801 79.4421 21.6016 78.545 21.6016 77.4692V60.5005C21.6016 58.1451 23.5181 56.2285 25.8739 56.2285H50.075C51.1379 56.2285 52.0266 56.9896 52.2246 57.9959H43.5398C43.0975 57.9959 42.7391 58.3543 42.7391 58.7966C42.7391 59.239 43.0975 59.5974 43.5398 59.5974H53.0666H53.0676H53.4783C54.5349 59.5974 55.4196 60.3497 55.6244 61.3469H30.5365C28.6597 61.3469 27.1326 62.8741 27.1326 64.7512V77.9622V77.9628V83.0281C25.9536 82.9946 25.0049 82.0252 25.0049 80.8382Z",
    fill: "#80DDC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1117 66.2075C49.2217 66.2075 47.6846 67.745 47.6846 69.6343C47.6846 71.524 49.222 73.0614 51.1117 73.0614C53.001 73.0614 54.5384 71.524 54.5384 69.6343C54.5384 67.745 53.001 66.2075 51.1117 66.2075ZM51.1117 71.4598C50.1051 71.4598 49.2861 70.6409 49.2861 69.6346C49.2861 68.628 50.1051 67.8091 51.1117 67.8091C52.118 67.8091 52.9369 68.628 52.9369 69.6346C52.9369 70.6409 52.118 71.4598 51.1117 71.4598Z",
    fill: "#80DDC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5977 59.1032C39.6177 59.1514 39.6424 59.1977 39.6712 59.2411C39.7003 59.2849 39.7337 59.3259 39.7706 59.3628C39.8076 59.3994 39.8482 59.4332 39.8923 59.4629C39.9355 59.4917 39.9827 59.5164 40.0309 59.5364C40.0788 59.5564 40.1294 59.5718 40.1807 59.5821C40.2317 59.5924 40.2846 59.5974 40.3368 59.5974C40.3897 59.5974 40.4416 59.5924 40.4939 59.5821C40.5448 59.5718 40.5946 59.5564 40.6434 59.5364C40.6915 59.5164 40.7378 59.4917 40.7813 59.4629C40.8251 59.4332 40.8661 59.3994 40.903 59.3628C40.9405 59.3259 40.9734 59.2849 41.0031 59.2411C41.0319 59.1977 41.0566 59.1514 41.0766 59.1032C41.0966 59.0544 41.112 59.004 41.1223 58.9537C41.1326 58.9014 41.1376 58.8486 41.1376 58.7966C41.1376 58.7444 41.1326 58.6915 41.1223 58.6406C41.112 58.5893 41.0966 58.5386 41.0766 58.4907C41.0566 58.4419 41.0319 58.3953 41.0031 58.3521C40.9734 58.308 40.9405 58.2674 40.903 58.2305C40.8661 58.1936 40.8251 58.1601 40.7813 58.131C40.7378 58.1022 40.6915 58.0775 40.6434 58.0575C40.5946 58.0375 40.5448 58.0221 40.4939 58.0118C40.3903 57.9909 40.284 57.9909 40.1807 58.0118C40.1294 58.0221 40.0788 58.0375 40.0309 58.0575C39.9827 58.0775 39.9355 58.1022 39.8923 58.131C39.8482 58.1601 39.8076 58.1936 39.7706 58.2305C39.7337 58.2674 39.7003 58.308 39.6712 58.3521C39.6424 58.3953 39.6177 58.4419 39.5977 58.4907C39.5776 58.5386 39.5623 58.5893 39.552 58.6406C39.5417 58.6915 39.536 58.7444 39.536 58.7966C39.536 58.8486 39.5417 58.9014 39.552 58.9537C39.5623 59.004 39.5776 59.0544 39.5977 59.1032Z",
    fill: "#80DDC7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.875 37.3972V48.2566C77.875 49.1182 77.1741 49.8191 76.3125 49.8191H45.6875C44.8259 49.8191 44.125 49.1182 44.125 48.2566V37.3972H41V48.2566C41 50.8413 43.1028 52.9441 45.6875 52.9441H76.3125C78.8972 52.9441 81 50.8413 81 48.2566V37.3972H77.875Z",
    fill: "#EA365C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61 13L51.2903 22.7097L53.5 24.9194L59.4375 18.9819V43.3347H62.5625V18.9819L68.5 24.9194L70.7097 22.7097L61 13Z",
    fill: "#EA365C"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.5,
    cy: 15.5,
    rx: 15.5,
    ry: 15.5,
    transform: "rotate(180 19.5 15.5)",
    fill: "url(#paint0_linear_309_19712)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_309_19712",
    x1: 19.5,
    y1: -9.53674e-7,
    x2: 19.5,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB416"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB416",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasking1);
export default __webpack_public_path__ + "static/media/masking-1.87d0571c9bc5b6e29ebb0259f029f8cf.svg";
export { ForwardRef as ReactComponent };